import { render, staticRenderFns } from "./BindingWizardModal.vue?vue&type=template&id=492999e2&lang=pug&"
import script from "./BindingWizardModal.vue?vue&type=script&lang=ts&"
export * from "./BindingWizardModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports